import React from "react";
import { Box, Typography } from "@mui/material";
import { dash } from "./dashboardTokens";

/**
 * Section header — editorial hierarchy, optional action aligned top.
 */
export default function DashboardSection({ title, description, action, children, sx = {} }) {
  return (
    <Box sx={{ mb: 2.5, ...sx }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { sm: "flex-start" },
          justifyContent: "space-between",
          gap: { xs: 1.5, sm: 2 },
          mb: 2,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 700,
              fontSize: 15,
              letterSpacing: "-0.01em",
              color: "text.primary",
            }}
          >
            {title}
          </Typography>
          {description && (
            <Typography
              variant="body2"
              sx={{
                mt: 0.5,
                color: dash.textMuted,
                maxWidth: 720,
                lineHeight: 1.55,
                fontSize: 13,
              }}
            >
              {description}
            </Typography>
          )}
        </Box>
        {action && <Box sx={{ flexShrink: 0, alignSelf: { xs: "stretch", sm: "flex-start" } }}>{action}</Box>}
      </Box>
      {children}
    </Box>
  );
}
